module.exports = __webpack_public_path__ + "static/media/bg.f1675e02.jpg";